import { css } from 'emotion';

import {
  ISettingsColors,
  ButtonStyle,
} from '@wix/podcasts-common/dist/settings';
import getButtonStyles from '../../../lib/styles/getButtonStyles';

function getOutlineButtonStyle(buttonStyle) {
  return (
    {
      [ButtonStyle.ROUND_FULL]: ButtonStyle.ROUND_OUTLINE,
      [ButtonStyle.SQUARE_FULL]: ButtonStyle.SQUARE_OUTLINE,
    }[buttonStyle] || buttonStyle
  );
}

interface IGetStylesArgs {
  mainColors: ISettingsColors['main'];
  episodeColors: ISettingsColors['episode'];
  buttonStyle: ButtonStyle;
}

export default function getStyles({
  mainColors,
  episodeColors,
  buttonStyle,
}: IGetStylesArgs) {
  return {
    icon: css({
      fontSize: 16,
      lineHeight: 'inherit',

      '&:hover, &:focus': {
        opacity: 0.8,
      },
    }),

    mainHeader: css({
      color: mainColors.headerTitleColor,
    }),

    episodeHeader: css({
      color: episodeColors.headerTitleColor,
    }),

    feed: css({
      color: mainColors.episodeDescriptionColor,
    }),

    mobileButtonHeader: css({
      ...getButtonStyles({
        buttonStyle: getOutlineButtonStyle(buttonStyle),
        buttonColor: mainColors.headerTitleColor,
        buttonTextColor: mainColors.headerTitleColor,
        emptyButtonHoverTextColor: mainColors.headerBackgroundColor,
      }),
      marginTop: 18,
      width: '100%',
    }),

    mobileButtonEpisode: css({
      ...getButtonStyles({
        buttonStyle: getOutlineButtonStyle(buttonStyle),
        buttonColor: episodeColors.headerTitleColor,
        buttonTextColor: episodeColors.headerTitleColor,
        emptyButtonHoverTextColor: episodeColors.headerBackgroundColor,
      }),
      width: '100%',
      marginTop: 6,
    }),

    mobileButtonFeed: css({
      ...getButtonStyles({
        buttonStyle: getOutlineButtonStyle(buttonStyle),
        buttonColor: mainColors.episodeDescriptionColor,
        buttonTextColor: mainColors.episodeDescriptionColor,
        emptyButtonHoverTextColor: mainColors.episodeListBackgroundColor,
      }),
      float: 'right',
    }),
  };
}
